import { useFilter } from "@/utils";

function useCpf(cpf: string): { doc: string; valid: boolean } {
    const CPF = useFilter(cpf, { type: "number" });
    switch (true) {
        case CPF.length !== 11:
            return { doc: CPF, valid: false };
        case !!/(\d)\1{10}/.test(CPF):
            return { doc: CPF, valid: false };
    }

    let doc = CPF.split("").map((el) => +el);

    const rest = (count) =>
        ((doc
            .slice(0, count - 12)
            .reduce((soma, el, index) => soma + el * (count - index), 0) *
            10) %
            11) %
        10;
    return {
        doc: CPF,
        valid: rest(10) === doc[9] && rest(11) === doc[10],
    };
}

export { useCpf };
